import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom';
import api from '../../service/AxiosInstance';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import '../../assets/demo/flags/flags.css';
import '../../assets/demo/Demos.scss';
import '../../assets/layout/layout.scss';
import './Login.css';
import { Toast } from 'primereact/toast';
import MainComp from '../../MainComp';
import { InputMask } from 'primereact/inputmask';



const Login = () => {

    const [checked, setChecked] = useState(false);
    const toast = useRef(null);
    // const message = useRef(null);
    const [user, setUser] = useState({
        portable: '',
        pwd_portail: '',
        matricule: ''
    });

    // const [isAuthenticated, setAuth] = useState(localStorage.getItem("auth"));
    const [isAuthenticated, setAuth] = useState(false);

    const navigate = useHistory();


    const handleChange = (event) => {
        setUser({
            ...user,
            [event.target.name]: event.target.value
        });
    }


    const login = (e) => {

        e.preventDefault();
        api.post("User/Connect2/Ext", user,
            {
                Headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(user)
            }).then(res => {
                const _user = res.data;
                if (_user.numcont !== "Empty") {
                    localStorage.setItem("user_connect", JSON.stringify(res.data));
                    localStorage.setItem("auth", true);
                    setAuth(true);
                    navigate.push('/dashboard');

                } else {
                    localStorage.setItem("auth", false);
                    setAuth(false);
                    navigate.push('/login');

                    toast.current.show({
                        severity: 'error',
                        summary: 'Connexion',
                        detail: 'Login  ou Mot de Passe Incorrect !',
                        life: 5000,
                        style: { with: '100px' }
                    });
                }
            })



    }

    if (isAuthenticated) {
        return <MainComp />;

    }
    else {
        return (
            <>
                <Toast ref={toast} />


                {/* <div className="container toast-demo">
                    <section id="content">
                        <form method='post'>
                            <h1>WebLamps</h1>
                            <div>
                                <input type="text" placeholder="Login" name='login' value={user.login} onChange={handleChange} required="true" id="username" />
                            </div>
                            <div>
                                <input type="password" placeholder="Mot de passe" required="" id="password" name='password' value={user.password} onChange={handleChange} />
                            </div>
                            <div>

                                <input type="submit" onClick={login} value="Log in" />
                                <a href="#">S'enregistrer</a>


                            </div>
                        </form>
                        <div className="button">
                            <a href="#"><img src='assets/layout/images/favicon.png' alt="Logo" height="20" className="mr-2" />© By A2SMI</a>
                        </div>
                    </section>
                </div> */}

                <div className="container" style={{ backgroundImage: 'url("/assets/layout/images/bg-4.jpg")', backgroundSize: 'cover' }}>
                    <Toast ref={toast} />
                    <div className="surface-card p-4 shadow-2 border-round w-full lg:w-3">
                        <div className="text-center mb-2">

                            <img src="assets/layout/images/logo-dss.jpg" alt="log0_nma" height={180} className="mb-1" />
                            {/* <img src="assets/layout/images/favicon.ico" alt="log0_nma" height={50} className="mb-1" /> */}
                            <div className="text-800 text-xl font-medium mb-1">WEBLAMPS IPM</div>

                            <img src="assets/layout/images/favicon.ico" alt="log0_nma" height={50} className="mb-1" />
                            {/* <span className="text-600 font-medium line-height-3">Mon Espace Personnel</span> */}
                            {/* <a className="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create today!</a> */}
                        </div>

                        <div>
                            <label htmlFor="username" className="block text-900 font-medium mb-2">Login (N° Téléphone Portable)</label>
                            <InputMask id="username" mask="99-999-99-99" placeholder="99-999-99-99" name='portable' value={user.portable} onChange={handleChange} required="true" className="w-full mb-3" />

                            <label htmlFor="password" className="block text-900 font-medium mb-2">Mot de Passe</label>
                            <InputText type="password" placeholder="Mot de passe" required="" id="password" name='pwd_portail' value={user.pwd_portail} onChange={handleChange} className="w-full mb-3" />

                            <div className="flex align-items-center justify-content-between mb-6">
                                <div className="flex align-items-center">
                                    <Checkbox id="rememberme" onChange={e => setChecked(e.checked)} checked={checked} className="mr-2" />
                                    <label htmlFor="rememberme">Remember Me</label>
                                </div>
                                {/* <a href='#' className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">Changer Mot de Passe ?</a> */}
                            </div>

                            <Button label="Se Connecter" icon="pi pi-user" className="w-full" onClick={login} />
                        </div>
                    </div>
                </div>
            </>


        );
    }

}

export default Login;
